import React from "react";
import MobileLayout from "../../Shared/MobileLayout";
import MobileNotice from "../../Shared/MobileNotice";
import OriginalComponentImpl from "../../../Components/Main/HomePage/Authentication/ResetPassword";

const OriginalComponent = OriginalComponentImpl as unknown as React.ComponentType<any>;

interface Props {
  [key: string]: any;
}

const ResetPasswordMobile: React.FC<Props> = (props) => {
  return (
    <MobileLayout title="ResetPassword">
      <MobileNotice page="ResetPassword" />
      <OriginalComponent {...props} />
    </MobileLayout>
  );
};

export default ResetPasswordMobile;